export default "__VITE_ASSET__BoUhGNeJ__"